export const formStyles = () => ({
  form: {
    padding: '5%',
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  input: {
    marginTop: '1em',
    width: '90%',
    lineHeight: 'normal',
  },
  textinput: {
    width: '85%',
  },
  button: {
    display: 'flex',
    fontSize: 16,
    marginLeft: '7.5%',
    width: '85%',
    backgroundColor: '#2196f3',
    color: 'white',
    paddingTop: 15,
    paddingBottom: 15,
    '&:hover': {
      backgroundColor: '#0069c0',
    },
  },
  cardActions: {
    marginBottom: '5%',
  },
  loadingIndicator: {
    color: 'white',
  },
  forgotPasswordLink: {
    display: 'flex',
    fontWeight: 'bold',
    marginLeft: '7.5%',
    width: '85%',
    color: '#2196f3',
    textDecoration: 'none',
    '&:hover': {
      color: '#0069c0',
    },
  },
});

export const pageStyles = () => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    alignItems: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: 'rgb(225, 225, 225)',
  },
  card: {
    width: 550,
    marginTop: '6em',
  },
  avatar: {
    margin: '1em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: 50,
    height: 50,
    marginTop: '2%',
  },
});
